import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

export const FeatureUpsellModal = ({
  id,
  feature,
}: {
  id: string;
  feature: 'campaigns' | 'calendar';
}) => {
  const { t, i18n } = useTranslation('payments');
  const navigate = useNavigate();
  const { agentId } = useParams();

  const copy = {
    campaigns: {
      en: {
        title: 'Unlock Campaigns with a Subscription',
        body: 'Boost your reach and convert more leads. With Campaigns, you can send targeted messages, schedule sends, and track results in real time. Upgrade now to start launching high‑impact campaigns in minutes.',
        cta: 'Upgrade Plan',
        cancel: 'Not now',
      },
      es: {
        title: 'Activa Campañas con una Suscripción',
        body: 'Impulsa tu alcance y convierte más clientes. Con Campañas puedes enviar mensajes segmentados, programar envíos y medir resultados en tiempo real. Actualiza ahora y lanza campañas de alto impacto en minutos.',
        cta: 'Actualizar plan',
        cancel: 'Ahora no',
      },
    },
    calendar: {
      en: {
        title: 'Unlock Calendar Scheduling with a Subscription',
        body: 'Let clients book you 24/7. Share links, avoid back‑and‑forth, and reduce no‑shows with automatic reminders. Upgrade now and start filling your calendar effortlessly.',
        cta: 'Upgrade Plan',
        cancel: 'Not now',
      },
      es: {
        title: 'Activa el Calendario con una Suscripción',
        body: 'Deja que tus clientes reserven 24/7. Comparte enlaces, evita idas y vueltas y reduce ausencias con recordatorios automáticos. Actualiza ahora y llena tu agenda sin esfuerzo.',
        cta: 'Actualizar plan',
        cancel: 'Ahora no',
      },
    },
  } as const;

  const lang = i18n.language?.startsWith('es') ? 'es' : 'en';
  const { title, body, cta, cancel } = copy[feature][lang];

  const close = () => {
    const dialog = document.getElementById(id) as HTMLDialogElement | null;
    dialog?.close();
  };

  const goToBilling = () => {
    close();
    if (agentId) navigate(`/agent/${agentId}/billing`);
  };

  return (
    <dialog id={id} className="modal">
      <div className="modal-box bg-base-100">
        <h3 className="text-lg font-bold">{title}</h3>
        <p className="py-4">{body}</p>
        <div className="modal-action">
          <button className="btn btn-primary" onClick={goToBilling}>
            {cta}
          </button>
          <button className="btn" onClick={close}>
            {cancel}
          </button>
        </div>
      </div>
      <form method="dialog" className="modal-backdrop backdrop-blur-sm">
        <button>close</button>
      </form>
    </dialog>
  );
};











